import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminAnnonceItem from '../../components/AdminAnnonceItem';
import SideBarAdmin from '../../components/SideBarAdmin';

import { useAxios } from '../../utils/hook/useAxios';
function AdminAnnoncesItemPage() {
  const [email, setEmail] = useState(null);
  const [annonce, setAnnonce] = useState(null);
  const axios = useAxios();
  const { annonceId } = useParams();

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(`/vehicleAnnonces/getannoncebyid/${annonceId}`);
        if (response.data) {
          setAnnonce(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <section className="bg-body-tertiary">
      <div className="container">
        <div className="row">
          <h1 className="mb-3">
            {annonce?.Vehicle?.VehicleModel?.marque} model {annonce?.Vehicle?.VehicleModel?.modele}{' '}
            annonce #{annonce?.vehiculeAnnonceId}
            <span className="px-2">
              {annonce?.status == '0' && (
                <i class="bi bi-clock-history text-warning h5"> En attente</i>
              )}
              {annonce?.status == '1' && (
                <i class="bi bi-check2-circle text-success h5"> Approuvée</i>
              )}
              {annonce?.status == '2' && (
                <i class="bi bi-exclamation-circle-fill text-warning h5"> Désactivée</i>
              )}
            </span>
          </h1>

          <div className="col-md-3 mb-3 d-none d-sm-block">
            <SideBarAdmin></SideBarAdmin>
          </div>
          <div className="col-md-8 mb-3">
            <AdminAnnonceItem data={annonce}></AdminAnnonceItem>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminAnnoncesItemPage;
